import React from 'react';

const SidebarHeadNonagon = () => (
    <svg
			width="31"
			height="30"
			viewBox="0 0 8.2020831 7.9375"
			xmlns="http://www.w3.org/2000/svg"
        >
        <g id="layer1">
            <path
				d="M 5.661813,7.8012 2.184951,7.591782 0.08328,7.028609 0,0.875301 1.91583,0.01743 5.619706,0 7.64079,0.631059 8.102426,6.765852 Z"
				style={{ fill: '#ffffff', strokeWidth: 0.0845707, strokeLinecap: 'round', strokeLinejoin: 'bevel' }}
            />
            <rect
            width="6.5279188"
            height="6.0954199"
            x="0.63058263"
            y="0.86934888"
            style={{ fill: '#171717' }}
            />
        </g>
    </svg>

)

const SidebarHeaderHexagon2 = () => (
    <svg
      width="31"
      height="30"
      viewBox="0 0 8.2020831 7.9375"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M 5.661813,7.8012 2.184951,7.591782 0.08328,7.028609 0,0.875301 1.91583,0.01743 5.619706,0 7.64079,0.631059 8.102426,6.765852 Z"
          style={{
            fill: '#ffffff',
            strokeWidth: '0.0845707',
            strokeLinecap: 'round',
            strokeLinejoin: 'bevel',
          }}
        />
        <rect
          width="6.5279188"
          height="6.0954199"
          x="0.63058263"
          y="0.86934888"
          style={{
            fill: '#171717',
            stroke: 'none',
            strokeWidth: '0.0924124',
            strokeLinecap: 'round',
            strokeLinejoin: 'bevel',
          }}
        />
      </g>
    </svg>
);

const HistoryIconSVG = ({fill}) => (
    <svg
		width="8mm"
		height="8mm"
		viewBox="0 0 8.2020831 7.9375"
		version="1.1"
		id="svg1"
    >
      <g
        id="layer1"
      >
        <g
			id="g70"
			style={{
				clipRule: 'evenodd',
				fill: `${fill}`,
				fillOpacity: 1,
				fillRule: 'evenodd',
				stroke: 'none',
				strokeOpacity: 1,
				imageRendering: 'optimizeQuality',
				shapeRendering: 'geometricPrecision',
				textRendering: 'geometricPrecision'
			}}
			transform="matrix(0.0865, 0, 0, 0.0929, -0.476, -0.506)"
        >
			<path
				fill={fill}
				d="M9.5,5.5c1.3734-0.15668 2.7068,0.00999 4,0.5 1.8501,2.01761 3.8501,3.85095 6,5.5 2.4092-2.41813 5.0759-4.41813 8-6 2.9241,1.58187 5.5908,3.58187 8,6 2.4092-2.41813 5.0759-4.41813 8-6 2.9241,1.58187 5.5908,3.58187 8,6 2.4092-2.41813 5.0759-4.41813 8-6 2.9241,1.58187 5.5908,3.58187 8,6 2.1499-1.64905 4.1499-3.48239 6-5.5 1.2932-0.49001 2.6266-0.65668 4-0.5v54c16.5354-1.279 23.035,6.3877 19.5,23-1.3999,3.4024-3.5665,6.2357-6.5,8.5-26,0.6667-52,0.6667-78,0C9.56655,88.7357 7.39988,85.9024 6,82.5 5.33333,58.1667 5.33333,33.8333 6,9.5 7.37561,8.29493 8.54227,6.9616 9.5,5.5z M17.5,23.5c9.3333,0 18.6667,0 28,0v4h-28v-4zM51.5,23.5h14v4h-14v-4zM17.5,31.5h14v4h-14v-4zM37.5,31.5h28v4h-28v-4zM17.5,39.5h10v4h-10v-4zM33.5,39.5h14v4h-14v-4zM53.5,39.5h12v4h-12v-4zM17.5,47.5h22v4h-22v-4zM45.5,47.5h20v4h-20v-4zM28.5,64.5c19.4957-1.1624 39.1624-1.3291 59-0.5 2.1175,0.2602 3.7842,1.2602 5,3-20.6667,0.6667-41.3333,0.6667-62,0-0.5659-0.9947-1.2326-1.828-2-2.5zM16.5,64.5c5.0976-1.0705 8.2643,0.9295 9.5,6 1.409,5.8163 0.2424,10.983-3.5,15.5-5.0962,1.5798-8.2629-0.2535-9.5-5.5-1.37791-5.9702-0.2112-11.3035 3.5-16z"
				id="path70"
			/>
        </g>
      </g>
    </svg>
);

const MenuCloseIcon = () => (
    <svg
      width="48"
      height="43"
      viewBox="0 0 12.7 11.377"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="layer1">
        <rect
          width="15.953"
          height="1.897"
          x="-6.796"
          y="7.545"
          ry="0.949"
          transform="rotate(-39.828794)"
          style={{ fill: '#7f8b9a', fillOpacity: 1, strokeWidth: 0.109, strokeLinecap: 'round', strokeLinejoin: 'bevel' }}
        />
        <rect
          width="15.953"
          height="1.897"
          x="0.509"
          y="-0.978"
          ry="0.949"
          transform="rotate(41.79156)"
          style={{ fill: '#7f8b9a', fillOpacity: 1, strokeWidth: 0.109, strokeLinecap: 'round', strokeLinejoin: 'bevel' }}
        />
      </g>
    </svg>
);

const MenuIcon = () => (
    <svg
      width="61"
      height="24"
      viewBox="0 0 16.139583 6.35"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="layer1">
        <rect
          style={{
            fill: "#7f8b9a",
            fillOpacity: 1,
            strokeWidth: 0.109,
            strokeLinecap: "round",
            strokeLinejoin: "bevel",
          }}
          width="15.953609"
          height="1.8971556"
          x="0"
          y="0"
          ry="0.94857782"
        />
        <rect
          style={{
            fill: "#7f8b9a",
            fillOpacity: 1,
            strokeWidth: 0.109,
            strokeLinecap: "round",
            strokeLinejoin: "bevel",
          }}
          width="11.204678"
          height="1.8971556"
          x="0"
          y="4.4508972"
          ry="0.94857782"
        />
      </g>
    </svg>
);
  
const MenulistPentagonIcon = ({fill}) => (
    <svg
      width="34"
      height="34"
      viewBox="0 0 8.9958331 8.9958333"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M 17.638237,91.528148 C 15.957022,92.368756 0.41493948,89.78604 -0.90405016,88.446871 -2.2230398,87.107703 -4.5694987,71.528201 -3.7034636,69.859941 c 0.866035,-1.668259 14.9579256,-8.714205 16.8121546,-8.406077 1.854229,0.308127 12.909955,11.532995 13.189896,13.391688 0.279942,1.858693 -6.979134,15.841988 -8.66035,16.682596 z"
          transform="matrix(0.29005543,-0.05521881,0.05473289,0.29690704,-2.737793,-17.522206)"
          fill={fill}
          fillOpacity="1"
          strokeWidth="0.09"
          strokeLinecap="round"
          strokeLinejoin="bevel"
        />
        <rect
          width="4.7191792"
          height="0.84271055"
          x="2.2284129"
          y="6.6429124"
          ry="0.42135528"
          fill="#ffffff"
          fillOpacity="1"
          strokeWidth="0.09"
          strokeLinecap="round"
          strokeLinejoin="bevel"
        />
      </g>
    </svg>
);

const RegisteredCheckCircle = () => (
    <svg width="250" height="50" viewBox="0 0 250 50" xmlns="http://www.w3.org/2000/svg" >
        {/*<!-- Stationary Circle in the Middle -->*/}
        <circle cx="125" cy="50" r="50" fill="#06ff00ff" />
    
        {/*Expanding Circles*/}
        <circle cx="125" cy="50" r="10" fill="rgba(6,255,0,0.5)" stroke="#06ff00ff" strokeWidth="4">
			<animate attributeName="r" from="10" to="150" dur="2s" repeatCount="indefinite" />
			<animate attributeName="opacity" from="1" to="0" dur="2s" repeatCount="indefinite" />
        </circle>
    </svg>
);
  
const CheckMarkIcon = () => (
    <svg
      width="5mm"
      height="3mm"
      viewBox="0 0 5 3"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        style={{
          clipRule: 'evenodd',
          fill: '#06ff00',
          fillOpacity: 1,
          fillRule: 'evenodd',
          strokeWidth: 0.533218,
          imageRendering: 'optimizeQuality',
          shapeRendering: 'geometricPrecision',
          textRendering: 'geometricPrecision',
        }}
        transform="matrix(0.10382895, 0, 0, 0.09030537, -9.3942468, -8.5915752)"
      >
        <path
          style={{ opacity: 0.84, fill: '#06ff00', fillOpacity: 1, strokeWidth: 0.533218 }}
          fill="#000000"
          d="m 131.5,95.5 c 6.174,-1.3271 8.341,1.0062 6.5,7 -9.167,8.5 -18.333,17 -27.5,25.5 -2.471,0.706 -4.805,0.373 -7,-1 -4.1667,-4.167 -8.3333,-8.333 -12.5,-12.5 -1.3138,-3.681 -0.1471,-6.014 3.5,-7 4.619,3.446 9.119,7.112 13.5,11 7.812,-7.797 15.646,-15.463 23.5,-23 z"
        />
      </g>
    </svg>
);

const CampaignIcon = ({fill}) => (
	<svg
		width="10.127mm"
		height="8mm"
		viewBox="0 0 10.127 8"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g transform="matrix(0.0624,0,0,0.0624,-0.904,-0.714)">
			<path 
				d="M 101.5,11.5 c 3.23,-0.34 4.73,1 4.5,4 -4.59,1.91 -6.08,0.58 -4.5,-4 z" 
				fill={fill}
			/>
			<path 
				d="M 33.5,19.5 c 7.08,-1.94 11.41,0.56 13,7.5 -2.58,8.63 -7.58,10.46 -15,5.5 -2.71,-4.83 -2.04,-9.17 2,-13 z" 
				fill={fill}
			/>
			<path 
				d="M 78.5,28.5 c 3.52,-0.31 4.86,1 4,4 -4.36,1.64 -5.69,0.31 -4,-4 z" 
				fill={fill}
			/>
			<path 
				d="M 114.5,35.5 c 1.67,0.25 3.17,0.92 4.5,2 0.67,24.67 0.67,49.33 0,74 -2.64,1.56 -4.98,1.23 -7,-1 -0.67,-24 -0.67,-48 0,-72 0.7,-1.19 1.53,-2.19 2.5,-3 z" 
				fill={fill}
			/>
			<path 
				d="M 108.5,42.5 c 1.33,20.84 1.33,41.84 0,63 -11.16,-7.74 -23.49,-12.41 -37,-14 -0.33,-11.35 0,-22.69 1,-34 13.07,-2.68 25.07,-7.68 36,-15 z M 101.5,55.5 c 1.33,5.96 2,12.3 2,19 -0.33,6.33 -0.67,12.67 -1,19 -1,-12.65 -1.33,-25.32 -1,-38 z M 94.5,65.5 c 0.62,0.11 1.12,0.44 1.5,1 0.17,2.67 0.33,5.33 0.5,8 -1,12 -2,12 -3,0 0.04,-3.08 0.38,-6.08 1,-9 z M 87.5,69.5 c 1.28,1.19 1.94,2.86 2,5 -0.33,1.67 -0.67,3.33 -1,5 -0.99,-3.27 -1.32,-6.6 -1,-10 z" 
				fill={fill}
			/>
			<path 
				d="M 138.5,42.5 c 3.52,-0.31 4.86,1 4,4 -4.36,1.64 -5.69,0.31 -4,-4 z" 
				fill={fill}
			/>
			<path 
				d="M 15.5,46.5 c 2.46,-0.27 4.12,0.73 5,3 -2.05,3.97 -4.05,3.97 -6,0 0.19,-1.08 0.52,-2.08 1,-3 z" 
				fill={fill}
			/>
			<path 
				d="M 43.5,57.5 h 26 v 33 h -26 v -33 z M 48.5,61.5 c 5.34,-0.17 10.68,0 16,0.5 1.33,8 1.33,16 0,24 -5.66,0.5 -11.32,0.67 -17,0.5 -0.3,-8.42 0.03,-16.75 1,-25 z" 
				fill={fill}
			/>
		</g>
	</svg>
)

const ImpactIcon = ({fill}) => (
	<svg
		width="8mm"
		height="8mm"
		viewBox="0 0 8 8"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g transform="matrix(0.05132619,0,0,0.05124039,-0.08014099,-0.07206904)">
			<path
				style={{
					opacity: 0.826,
					fill: `${fill}`,
					fillOpacity: 1,
				}}
				d="M 74.5,1.5 C 91.6055,0.457977 102.439,8.12464 107,24.5 108.525,41.6241 101.025,52.4575 84.5,57 67.3759,58.5254 56.5425,51.0254 52,34.5 50.5915,17.2918 58.0915,6.2918 74.5,1.5 Z m 1,6 c 11.3794,-0.89514 19.5461,3.7715 24.5,14 2.911,9.2599 0.911,17.2599 -6,24 -0.3333,-3.6667 -0.6667,-7.3333 -1,-11 -1.3375,-2.5021 -3.1708,-4.5021 -5.5,-6 3.6137,-6.9273 1.9471,-12.0939 -5,-15.5 -7.5857,-1.2124 -11.919,1.9543 -13,9.5 0.0939,2.1885 0.7606,4.1885 2,6 -2.3292,1.4979 -4.1625,3.4979 -5.5,6 -0.3333,3.6667 -0.6667,7.3333 -1,11 C 54.4656,33.2534 55.2989,21.7534 67.5,11 c 2.6579,-1.47797 5.3245,-2.64463 8,-3.5 z m 3,11 c 4.8284,1.1411 5.8284,3.6411 3,7.5 -3.3139,1.1647 -5.3139,-0.0019 -6,-3.5 0.6716,-1.6595 1.6716,-2.9928 3,-4 z m -4,16 c 4.4113,-0.479 8.578,0.1876 12.5,2 0.4992,4.6548 0.6658,9.3215 0.5,14 -5.3333,1.3333 -10.6667,1.3333 -16,0 -0.1658,-4.6785 8e-4,-9.3452 0.5,-14 0.9947,-0.5659 1.828,-1.2326 2.5,-2 z"
			/>
			<path
				style={{
					opacity: 0.832,
					fill: `${fill}`,
					fillOpacity: 1,
				}}
				d="m 76.5,64.5 c 2,0 4,0 6,0 0,14 0,28 0,42 3.0184,-0.165 6.0184,0.002 9,0.5 0.5585,0.725 0.8918,1.558 1,2.5 -3.2652,5.775 -6.7652,11.442 -10.5,17 -1.6667,1.333 -3.3333,1.333 -5,0 -3.7348,-5.558 -7.2348,-11.225 -10.5,-17 0.1082,-0.942 0.4415,-1.775 1,-2.5 2.9816,-0.498 5.9816,-0.665 9,-0.5 0,-14 0,-28 0,-42 z m -1,49 c 8.158,-2.568 9.4914,-0.901 4,5 -1.3872,-1.71 -2.7206,-3.377 -4,-5 z"
			/>
			<path
				style={{
					opacity: 0.806,
					fill: `${fill}`,
					fillOpacity: 1,
				}}
				d="m 45.5,89.5 c 2.2664,1.6933 2.5997,3.8599 1,6.5 -14.1876,2.3434 -26.3543,8.51 -36.5,18.5 -3.23184,5.032 -3.23184,10.032 0,15 5.3977,6.06 11.8977,10.56 19.5,13.5 30.0233,10.091 60.3567,11.091 91,3 12.083,-2.78 21.916,-8.947 29.5,-18.5 2.039,-4.487 1.706,-8.82 -1,-13 -10.146,-9.99 -22.312,-16.1566 -36.5,-18.5 -1.269,-2.1385 -1.269,-4.3052 0,-6.5 12.116,2.5588 23.449,7.0588 34,13.5 14.228,12.023 14.562,24.356 1,37 -13.602,9.091 -28.602,14.424 -45,16 -24.4558,3.288 -48.4558,1.288 -72,-6 C 20.4153,146.879 11.9153,141.379 5,133.5 0.103118,125.253 0.436451,117.253 6,109.5 12.7634,102.197 20.93,97.0302 30.5,94 c 5.1475,-1.442 10.1475,-2.942 15,-4.5 z m 30,24 c 1.2794,1.623 2.6128,3.29 4,5 5.4914,-5.901 4.158,-7.568 -4,-5 z"
			/>
			<path
				style={{
					opacity: 0.805,
					fill: `${fill}`,
					fillOpacity: 1,
				}}
				d="m 50.5,102.5 c 3.9851,-0.06 5.6518,1.94 5,6 -7.6552,1.078 -14.1552,4.411 -19.5,10 -1.5667,5.033 -0.0667,8.867 4.5,11.5 26,12.667 52,12.667 78,0 6.197,-4.687 6.53,-9.687 1,-15 -4.832,-3.443 -10.165,-5.61 -16,-6.5 -0.475,-2.823 0.525,-4.823 3,-6 9.402,1.776 16.902,6.442 22.5,14 1.886,7.049 0.053,12.882 -5.5,17.5 -7.028,4.566 -14.695,7.566 -23,9 -15.7259,2.22 -31.3926,1.887 -47,-1 -8.2645,-1.881 -15.4312,-5.714 -21.5,-11.5 -4.9943,-9.624 -2.8276,-17.124 6.5,-22.5 3.9755,-2.146 7.9755,-3.98 12,-5.5 z m 25,11 c 1.2794,1.623 2.6128,3.29 4,5 5.4914,-5.901 4.158,-7.568 -4,-5 z"
			/>
		</g>
	</svg>
)

const AccountInfoIcon = ({fill}) => (
	<svg
		width="8mm"
		height="8mm"
		viewBox="0 0 8.0000001 8"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g
			style={{
				clipRule: 'evenodd',
				fill: `${fill}`,
				fillOpacity: 1,
				fillRule: 'evenodd',
				imageRendering: 'optimizeQuality',
				shapeRendering: 'geometricPrecision',
				textRendering: 'geometricPrecision',
			}}
			transform="matrix(0.09756098, 0, 0, 0.09302328, -1.0243903, -0.51162804)"
		>
		<path
			style={{ 
				opacity: 0.953, 
				fill: `${fill}`, 
				fillOpacity: 1 
			}}
			fill="#000000"
			d="m 48.5,5.5 c 8.4159,0.1276 15.5826,3.1276 21.5,9 0.8221,2.2885 1.4888,4.6218 2,7 -0.6841,7.7203 -1.0174,15.3869 -1,23 -4.0343,5.7379 -6.701,12.0712 -8,19 -1.3189,1.9875 -3.1523,3.1541 -5.5,3.5 -5.0893,0.8257 -10.0893,0.4924 -15,-1 C 39.9727,63.4264 38.806,60.2597 39,56.5 36.8499,52.3702 34.5166,48.3702 32,44.5 32.7178,38.3273 32.5512,32.1607 31.5,26 31.2383,14.1054 36.9049,7.2721 48.5,5.5 Z"
		/>
		<path
			style={{ 
				opacity: 0.956, 
				fill: `${fill}`, 
				fillOpacity: 1
			}}
			fill="#000000"
			d="m 37.5,65.5 c 9.1673,6.639 18.334,6.639 27.5,0 6.5458,3.0226 13.0458,6.1893 19.5,9.5 4.9175,4.0015 7.5841,9.1682 8,15.5 -27.3333,1.3333 -54.6667,1.3333 -82,0 0.4159,-6.3318 3.0825,-11.4985 8,-15.5 6.5687,-2.8983 12.902,-6.065 19,-9.5 z"
		/>
		</g>
	</svg>
);

const EventRegistrationIcon = ({fill}) => (
	<svg
		width="8mm"
		height="8mm"
		viewBox="0 0 8 8"
		version="1.1"
		id="svg1"
	>
		<g
			id="layer1"
		>
			<g
				id="g89"
				style={{
					clipRule: "evenodd",
					fill: `${fill}`,
					fillOpacity: 1,
					fillRule: "evenodd",
					imageRendering: "optimizeQuality",
					shapeRendering: "geometricPrecision",
					textRendering: "geometricPrecision",
				}}
				transform="matrix(0.0527, 0, 0, 0.0506, -0.3403, -0.0197)"
			>
			<path
				style={{
					opacity: 0.913,
					fill: `${fill}`,
					fillOpacity: 1,
				}}
				d="m 45.5,0.5 c 2.5444,-0.395674 4.7111,0.270993 6.5,2 0.4995,5.99076 0.6662,11.9908 0.5,18 18,0 36,0 54,0 -0.166,-6.0092 0.001,-12.00924 0.5,-18 2.075,-2.148344 4.408,-2.4816775 7,-1 0.5,6.32458 0.666,12.6579 0.5,19 19.018,-2.5888 31.518,5.0778 37.5,23 0.667,7 0.667,14 0,21 -2.075,2.1483 -4.408,2.4817 -7,1 -0.499,-3.9862 -0.666,-7.9862 -0.5,-12 -43.333,0 -86.6667,0 -130,0 -0.1666,25.3355 0,50.669 0.5,76 1.1374,10.807 6.9708,17.64 17.5,20.5 12.3333,0.333 24.6667,0.667 37,1 2.6667,2.333 2.6667,4.667 0,7 -13.6667,0.667 -27.3333,0.667 -41,0 C 16.8899,154.724 9.72321,147.224 7,135.5 6.02952,103.452 6.36285,71.4522 8,39.5 c 7.4098,-15.1241 19.5765,-21.4575 36.5,-19 -0.2934,-6.7554 0.0399,-13.42206 1,-20 z m -13,28 c 31.3351,-0.1666 62.6684,0 94,0.5 8.361,2.1938 14.028,7.3604 17,15.5 -42.667,1.3333 -85.3333,1.3333 -128,0 3.15,-8.1541 8.8167,-13.4874 17,-16 z"
				id="path89"
			/>
			</g>
			<g
				id="g90"
				style={{
					clipRule: "evenodd",
					fill: `${fill}`,
					fillOpacity: 1,
					fillRule: "evenodd",
					imageRendering: "optimizeQuality",
					shapeRendering: "geometricPrecision",
					textRendering: "geometricPrecision",
				}}
				transform="matrix(0.0527, 0, 0, 0.0506, -0.3403, -0.0197)"
			>
			<path
				style={{
					opacity: 0.862,
					fill: `${fill}`,
					fillOpacity: 1,
				}}
				d="m 105.5,62.5 c 28.138,-0.337 45.638,12.9964 52.5,40 2.453,29.199 -10.381,47.699 -38.5,55.5 C 88.0073,160.493 69.174,146.326 63,115.5 62.6225,86.0545 76.7892,68.3878 105.5,62.5 Z m -2,9 c 22.919,-1.631 38.086,8.369 45.5,30 3.374,23.614 -6.126,39.447 -28.5,47.5 -24.9089,3.633 -41.0756,-6.533 -48.5,-30.5 -2.3188,-24.4775 8.1812,-40.1442 31.5,-47 z"
				id="path90"
			/>
			</g>
			<g
				id="g91"
				style={{
					clipRule: "evenodd",
					fill: `${fill}`,
					fillOpacity: 1,
					fillRule: "evenodd",
					imageRendering: "optimizeQuality",
					shapeRendering: "geometricPrecision",
					textRendering: "geometricPrecision",
				}}
				transform="matrix(0.0527, 0, 0, 0.0506, -0.3403, -0.0197)"
			>
			<path
				style={{
					opacity: 0.84,
					fill: `${fill}`,
					fillOpacity: 1,
				}}
				d="m 131.5,95.5 c 6.174,-1.3271 8.341,1.0062 6.5,7 -9.167,8.5 -18.333,17 -27.5,25.5 -2.471,0.706 -4.805,0.373 -7,-1 -4.1667,-4.167 -8.3333,-8.333 -12.5,-12.5 -1.3138,-3.681 -0.1471,-6.014 3.5,-7 4.619,3.446 9.119,7.112 13.5,11 7.812,-7.797 15.646,-15.463 23.5,-23 z"
				id="path91"
			/>
			</g>
		</g>
	</svg>
);
  
const RequestFormEasyIcon = () => (
	<svg width="50" height="37" viewBox="0 0 50 37" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M24.3486 9.53905L25.2904 9.26487L26.2202 8.9311L27.15 8.59732L28.0798 8.25162L29.0573 8.03705L29.9871 7.70327L30.8692 7.23837L31.8229 6.97612L32.7646 6.65426L33.6944 6.35624L34.6004 5.93902L35.5302 5.61717L36.4957 5.37876L37.4017 4.96153L38.3434 4.67544L39.309 4.44895L40.215 4.03173L41.1567 3.74563L42.0746 3.32841L43.0521 3.13768L43.9938 2.82775L44.9355 2.50589L45.8296 2.06483L46.8071 1.82641L47.7488 1.51648L48.7024 1.20654L49.2389 2.06483L48.8216 2.98271L48.2971 3.85292L47.713 4.66352L47.2124 5.54564L46.7713 6.45161L46.2945 7.33373L45.7223 8.16818L45.2693 9.06222L44.7567 9.93243L44.2203 10.7788L43.7554 11.6848L43.207 12.5311L42.6587 13.3775L42.2653 14.3073L41.7646 15.1775L41.1925 16.0239L40.6322 16.8583L40.203 17.7762L39.607 18.5987L39.154 19.4928L38.6653 20.3749L38.2123 21.2689L37.5924 22.0676L37.1275 22.9736L36.5911 23.8319L36.162 24.7378L35.5182 25.5365L35.0295 26.4186L34.6004 27.3365L34.1116 28.2186L33.5394 29.065L33.0626 29.959L32.4904 30.7935L32.109 31.7471L31.5248 32.5697L30.9884 33.4399L30.452 34.2981L30.0348 35.2399L29.4626 36.0862L28.2467 36.3366L27.5791 35.6094L26.8043 34.9895L26.0056 34.4054L25.3619 33.6544L24.6347 32.9869L23.991 32.2359L23.3592 31.473L22.7036 30.7339L22.1195 29.9352L21.3923 29.2557L20.8797 28.3974L20.2599 27.6345L19.5566 28.3021L18.7936 28.8981L18.0665 29.5418L17.3512 30.2094L16.5883 30.8054L15.8254 31.4134L15.0625 32.0452L14.4188 32.6769L14.2996 31.7591L14.1804 30.7696L14.1327 29.7802L14.0492 28.7789L13.93 27.7895L13.9062 26.8001L13.8585 25.7988L13.6916 24.8093V23.7961L13.5009 22.8067L12.4996 22.6756L11.4863 22.5683L10.4611 22.4491L9.43596 22.3537L8.43463 22.1153L7.4929 21.6981L6.52733 21.3762L5.59753 20.9351L4.63196 20.5894L3.77368 20.0292L2.97499 19.3974L2.20016 18.7298L1.49684 18.0146L1.29419 17.2159L1.83062 16.5484L2.79619 16.1907L3.76175 15.9046L4.75116 15.6305L5.74058 15.3682L6.70614 15.0702L7.64787 14.6768L8.60152 14.3192L9.62669 14.1523L10.5923 13.8305L11.5459 13.4371L12.5234 13.151L13.5009 12.853L14.4545 12.4954L15.4082 12.102L16.3976 11.8278L17.3751 11.5059L18.3526 11.2199L19.3658 10.9934" stroke="#333333" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M13.5132 22.7947C17.1609 22.8186 25.6245 17.192 25.6245 17.192" stroke="#333333" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M31.8707 9.24101L31.7634 8.72843L31.6561 8.21584L31.5012 7.71518L31.1793 7.30988L30.8932 6.85689L30.5118 6.48735L30.1541 6.09397L29.6892 5.85556L29.2243 5.61715L28.7118 5.53371L28.1992 5.48602H27.6747L27.174 5.66483L26.6614 5.79596L26.2323 6.11781L25.7793 6.39199L25.3978 6.76153L25.0283 7.14299L24.6945 7.56021L24.3727 7.98935L24.1223 8.46617L23.9554 7.95359L23.7289 7.46484L23.5501 6.95226L23.2521 6.51119L22.9064 6.11781L22.6203 5.67675L22.215 5.34298L21.762 5.09264L21.3091 4.83039L20.8084 4.71118L20.2958 4.65158H19.7832L19.2706 4.74695L18.77 4.90191L18.2812 5.10456L17.8998 5.48602L17.4825 5.80788L17.1726 6.20126L16.8865 6.60656L16.6481 7.04762L16.5051 7.53637L16.362 8.02511L16.2786 8.5377L16.3382 9.05028V9.56287L16.4335 10.0635L16.5885 10.5404L16.9104 11.4106H16.8984L17.1011 11.9112L17.411 12.3404L17.6256 12.8291L17.9117 13.2583L18.1739 13.7112L18.5196 14.1046L18.8653 14.498L19.1991 14.8914L19.5448 15.2848L19.9024 15.6662L20.272 16.0358L20.6653 16.3695L21.0706 16.6914L21.4521 17.049L21.8574 17.3828L22.2508 17.7166L22.668 18.0265L23.0614 18.3603L23.5382 18.1695L23.9674 17.8835L24.4561 17.7404L24.8733 17.4424L25.3382 17.2397L25.7793 16.9894L26.2084 16.7152L26.6614 16.4768L27.0548 16.155L27.4601 15.845L27.9012 15.5947L28.2945 15.2609L28.6641 14.9152L29.0455 14.5814L29.4628 14.2715L29.7489 13.8424L30.1422 13.5086L30.4402 13.0914L30.7263 12.6622L31.0005 12.2212L31.2508 11.7682L31.4773 11.3033L31.6323 10.8026L31.7396 10.29L31.7754 9.76552L31.8111 9.24101H31.8707Z" fill="#333333"/>
		<path d="M25.6123 17.1801L26.4587 16.6795L27.305 16.1669L28.1514 15.6662L28.9739 15.1179L29.8203 14.6053L30.6428 14.0688L31.5249 13.6159L32.3474 13.0794L33.1461 12.4953L34.0044 11.9947L34.815 11.4225L35.6614 10.886L36.4839 10.3735L37.3303 9.86088L38.1528 9.32445L38.9753 8.78802L39.7501 8.19199L40.5965 7.67941L41.4071 7.14298L42.2177 6.59463L43.0164 6.02244L43.8151 5.45025L44.6376 4.91382L45.4482 4.3774L46.235 3.80521L47.0217 3.23302L47.8085 2.66083L48.5714 2.07672" stroke="#333333" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M20.2481 27.6345L19.7236 26.8358L19.2706 26.0014L18.9487 25.1074L18.7222 24.1895L18.6746 23.2358L18.8176 22.306L19.1991 21.4358L19.8189 20.7206L20.5938 20.1841" stroke="#333333" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M9.78193 26.4544L2.40308 30.6385" stroke="#333333" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M9.78206 31.2226L6.08667 33.3087" stroke="#333333" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

const RequestFormPowerfulIcon = () => (
	<svg width="48" height="51" viewBox="0 0 48 51" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_547_6747)">
		<path d="M17.4761 5.38921L18.5613 5.36208L19.6601 5.38921L20.7589 5.36208L21.8577 5.37564H22.9429H24.0552L25.154 5.34851L26.2528 5.36208L27.3651 5.38921" stroke="#333333" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M31.8009 19.1579L31.6653 18.5745L31.4482 18.0184L31.1905 17.4758L30.77 17.0553L30.3766 16.5669L29.8882 16.1735L29.3456 15.8615L28.7623 15.6309L28.1655 15.441L27.5415 15.3867L26.9175 15.4274L26.2935 15.4817L25.7102 15.7123L25.1404 15.9565L24.6385 16.3227L24.1366 16.689L23.7296 17.1638L23.2956 17.6114L23.0243 18.1676L22.6173 18.6424L22.4138 19.1985L22.2104 18.6424L21.8305 18.1405L21.5457 17.5843L21.1251 17.1231L20.6911 16.689L20.2434 16.2549L19.6872 15.9565L19.1175 15.6987L18.5342 15.441L17.9102 15.346L17.2862 15.3867L16.6758 15.4681L16.0653 15.6038L15.4956 15.8751L14.9394 16.1599L14.4782 16.5805L14.0306 17.0146L13.6914 17.4893L13.393 17.9912L13.1624 18.5339L13.0674 19.1036L12.9589 19.6733L12.9182 20.2566L13.0674 20.8264L13.0946 21.4097L13.298 21.9658L13.5151 22.4949L14.0577 23.4173L14.017 23.4444L14.3426 23.9599L14.7359 24.4211L15.0886 24.923L15.4685 25.3978L15.8619 25.859L16.3231 26.266L16.7843 26.6594L17.2455 27.0663L17.7203 27.4597L18.1951 27.8531L18.7241 28.1651L19.226 28.5178L19.7415 28.8434L20.257 29.1825L20.786 29.5081L21.3015 29.8472L21.8577 30.1049L22.3731 30.4576L22.9157 30.1592L23.4041 29.7929L23.9603 29.5623L24.4486 29.1961L24.9641 28.8841L25.4931 28.5856L25.9815 28.233L26.4969 27.9074L26.9175 27.4733L27.3922 27.0935L27.867 26.7136L28.274 26.2796L28.7081 25.8726L29.115 25.4385L29.5627 25.0316L29.9154 24.5432L30.3223 24.0956L30.6614 23.5937L30.9599 23.0782L31.1905 22.522L31.4347 21.9794L31.6517 21.4232L31.7738 20.8399L31.8552 20.2566L31.8823 19.6598L31.8009 19.0765V19.1579Z" fill="#333333"/>
		<path d="M40.7539 19.7818L41.812 19.9446L42.8701 20.0803L43.9417 20.2159L44.9998 20.3516L46.0715 20.5008L47.1431 20.6364L46.9803 21.7759L46.8447 22.9018L46.6819 24.0277L46.5191 25.1672L46.3428 26.3067L46.1935 27.4326" stroke="#333333" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M4.95549 29.5759L3.92454 30.0914L3.05637 30.8239L2.20176 31.5835L1.5642 32.5195L1.04872 33.5098L1.03516 34.6086L1.46924 35.6667L2.44593 36.2635L3.43619 36.8061L4.54853 37.0232L5.63375 37.3216L6.75966 37.4301L7.89913 37.5115L9.02504 37.3759L10.1509 37.4166L11.2769 37.2674L12.4028 37.1317L13.5151 36.9418L14.6275 36.7926L15.7534 36.6841L16.8521 36.3992L17.9238 36.0736L18.9954 35.7209L20.1213 35.5039L21.2066 35.219L22.2782 34.8392L23.3227 34.378L24.3944 34.0117L25.466 33.6455L26.4834 33.1435L27.5551 32.7502L28.5453 32.194L29.6441 31.8413L30.5937 31.2037L31.6246 30.7289L32.6149 30.1999L33.6458 29.7116L34.6496 29.1961L35.5992 28.5721L36.6302 28.0837L37.5661 27.4326L38.5157 26.795L39.5195 26.2524L40.4148 25.547L41.4051 24.9909L42.2597 24.2177L43.1686 23.5394L44.1317 22.929L45.0541 22.2507L45.8816 21.4775L46.8583 20.8399" stroke="#333333" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M33.266 49.6659L32.1265 49.5981L30.987 49.693L29.8476 49.5574L28.7081 49.6116L27.5686 49.7337L26.4291 49.6659L25.2897 49.5845L24.1502 49.6116L23.0107 49.7202L21.8712 49.6252L20.7318 49.5981L19.5787 49.6795L18.4393 49.6252L17.2998 49.6388L16.1603 49.7473L15.0073 49.7337L13.8678 49.5845L12.7148 49.6116H11.5617L10.5036 49.5031L9.64902 48.852L9.10642 47.9567L8.76729 46.9393L8.86224 45.7998L8.88937 44.6604L8.80798 43.5344L8.75372 42.395L8.83511 41.2555L8.9165 40.116L8.84868 38.9766L8.9165 37.8371L8.88937 36.6976L8.93007 35.5446L8.88937 34.4051L8.84868 33.2656L8.82155 32.1261L8.75372 30.9867L8.84868 29.8472L8.9165 28.7077L8.82155 27.5682L8.86224 26.4288L8.76729 25.2757L8.80798 24.1363L8.86224 22.9968L8.76729 21.8573L8.80798 20.7178L8.9165 19.5648L8.94364 18.4253L8.83511 17.2858L8.88937 16.1464L8.90294 15.0069L8.84868 13.8539L8.78085 12.7144L8.87581 11.5749L8.94364 10.4219L8.79442 9.2824L8.9165 8.14292L8.75372 6.98989L8.79442 5.83685L8.76729 4.68381V3.53077L9.11998 2.51338L9.60833 1.59095L10.4901 0.953386L11.5617 0.817734L12.7012 0.85843L13.8407 0.8313L14.9801 0.912691L16.1196 0.777039L17.2591 0.88556L18.3986 0.777039L19.538 0.722778L20.6775 0.763474L21.817 0.790604L22.9564 0.88556L24.0959 0.777039L25.249 0.736343L26.3884 0.790604H27.5279L28.6674 0.736343L29.8204 0.790604L30.9599 0.817734L32.1129 0.8313L33.266 0.777039L34.3105 1.02121L35.1651 1.63164L35.8298 2.47268L35.9519 3.53077L36.0197 4.67024L35.9247 5.80972L35.9112 6.94919L35.8976 8.08866L36.0061 9.21457L35.9654 10.354L35.8976 11.4935L36.0061 12.633L35.9519 13.786L36.0604 14.9255L35.9112 16.065L36.0061 17.2045L35.9383 18.3439L35.8976 19.4834L36.074 20.6229L35.9926 21.7759L36.0197 22.9154L35.8841 24.0549L35.9926 25.1943V26.3338L35.979 27.4869L36.0197 28.6263L35.9654 29.7658L35.9247 30.9053V32.0447L36.0604 33.1842V34.3237L35.9926 35.4767L36.0333 36.6162V37.7557L35.9519 38.9087L35.9654 40.0482L35.9112 41.2012L35.8841 42.3407L35.9112 43.4802L35.979 44.6332L35.8976 45.7863L35.9383 46.9393L35.7891 47.9838L35.2194 48.8927L34.3105 49.476L33.266 49.6659Z" stroke="#333333" strokeLinecap="round" strokeLinejoin="round"/>
		</g>
		<defs>
		<clipPath id="clip0_547_6747">
		<rect width="47.4645" height="50.381" fill="white" transform="translate(0.356873 0.0445251)"/>
		</clipPath>
		</defs>
	</svg>
)

const RequestFormTruestedIcon = () => (
	<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_547_6760)">
			<path d="M2.40805 8.6242L2.3487 8.9666L2.19805 9.32726V9.71075L2.24827 10.1034L2.06109 10.464L2.11587 10.8567L2.03826 11.231L1.99717 11.6099L1.89674 11.9843L1.83282 12.3632L1.93782 12.7558L1.77804 13.1256L1.91956 13.5182L1.7963 13.8926L1.72325 14.2715L1.6913 14.6505L1.75978 15.0339L1.74151 15.4129L1.7826 15.7964L1.74608 16.1753L1.73695 16.5542L1.78717 16.9377L1.65021 17.3212L1.65934 17.7047V18.0882L1.82826 18.4671L1.81456 18.8506V19.2295L1.70043 19.6175L1.71412 20.001L1.80999 20.38L1.85108 20.7589L1.96522 21.1332L1.98348 21.5167L1.90587 21.9093L2.04739 22.2791V22.6626L2.12044 23.0415L2.0337 23.4387L2.12044 23.8131L2.14783 24.1966L2.35784 24.5527L2.26196 24.959L2.41262 25.3242V25.7168L2.55414 26.0821L2.57241 26.4701L2.64089 26.849L2.84176 27.2006L2.78241 27.6115L2.89198 27.9812L2.98785 28.351L3.20699 28.6889L3.2846 29.0632L3.37591 29.433L3.4946 29.7983L3.62243 30.1589L3.63157 30.5561L3.83701 30.8894L3.88722 31.2774L4.09723 31.6107L4.20223 31.9805L4.35289 32.332L4.42137 32.7155L4.54007 33.0807L4.77747 33.3957L4.88703 33.7655L5.13356 34.0714L5.23856 34.4412L5.4714 34.7516L5.63575 35.094L5.72706 35.4775L5.95989 35.7834L6.12881 36.1258L6.3662 36.4271L6.48947 36.7969L6.70404 37.1165L7.00535 37.3767L7.12405 37.7556L7.33862 38.0706L7.61254 38.3446L7.85907 38.6368L8.03712 38.9792L8.23343 39.3124L8.49365 39.5955L8.81323 39.8237L8.95019 40.2118L9.21954 40.4857L9.53912 40.7094L9.77195 41.0153L10.0367 41.2892L10.2833 41.5814L10.5435 41.8599L10.8813 42.0562L11.21 42.2616L11.4748 42.5356L11.7168 42.8369L12.0409 43.0423L12.3559 43.2569L12.6846 43.4532L12.9312 43.7636L13.2964 43.9052L13.616 44.106L13.9173 44.3434L14.2642 44.5032L14.5245 44.8091L14.8943 44.9324L15.1727 45.2154L15.506 45.4026L15.8667 45.5395L16.2045 45.713L16.5971 45.7769L16.8984 46.0235L17.2774 46.1056L17.5969 46.3202L17.9439 46.48L18.3183 46.5713L18.6241 46.8361L18.9894 46.9457L19.3683 47.0187L19.7153 47.1785L20.0759 47.3018L20.4685 47.3155L20.8109 47.4889L21.1625 47.6487H21.5551L21.8884 47.8816L22.2855 47.8679L22.6599 47.9409L23.0069 48.1327L23.3949 48.1555L23.7647 48.2696L23.9473 48.2148L24.1071 48.1418L24.4952 48.1327H24.8878L25.2667 48.0687L25.6 47.8177L25.9789 47.7629L26.3807 47.7766L26.7504 47.6761L27.0746 47.4113L27.4672 47.3931L27.8416 47.3063L28.2068 47.1922L28.5538 47.0278L28.9327 46.9502L29.2888 46.8041L29.6403 46.6581L29.9644 46.4344L30.3297 46.3202L30.6629 46.1239L31.0327 46.0189L31.3432 45.7815L31.7358 45.713L32.0234 45.4345L32.3613 45.2565L32.7493 45.1698L33.1008 45.0145L33.4295 44.8182L33.6852 44.5078L34.0185 44.3252L34.3517 44.138L34.6804 43.9417L34.9818 43.7088L35.3424 43.5536L35.5844 43.2386L35.9542 43.0925L36.2327 42.8277L36.5659 42.6269L36.817 42.3301L37.0909 42.0653L37.4288 41.8644L37.6616 41.554L37.9675 41.3212L38.1181 40.9331L38.4468 40.7231L38.7208 40.4583L38.9308 40.1342L39.2047 39.8694L39.4375 39.5681L39.7069 39.2942L39.9397 38.9928L40.1999 38.7098L40.3369 38.34L40.5697 38.0387L40.8756 37.7876L41.0034 37.4132L41.2545 37.1211L41.5239 36.838L41.6015 36.4408L41.8526 36.1486L42.1083 35.8565L42.1767 35.4593L42.3183 35.1077L42.5967 34.8247L42.6926 34.4458L42.8661 34.1079L43.0715 33.7838L43.14 33.3957L43.2861 33.0442L43.5737 32.752L43.7153 32.3959L43.7609 32.0033L43.8705 31.6381L44.0029 31.282L44.2037 30.9487L44.2357 30.5561L44.4046 30.2091L44.4685 29.8302L44.5872 29.4695L44.8064 29.1363L44.9068 28.7665L44.9251 28.3739L45.1031 28.0223L45.1351 27.6343L45.2538 27.2691L45.2264 26.8719L45.4044 26.5158L45.3633 26.1186L45.4957 25.7534L45.5597 25.3744L45.651 25.0001V24.612L45.7651 24.2422L45.7423 23.8542L45.861 23.4844L45.9934 23.1146L45.9386 22.722L45.9477 22.3385L46.0299 21.9641L46.0071 21.5761L46.1942 21.2063V20.8182L46.1075 20.4256V20.0421L46.1486 19.6586L46.2855 19.2797L46.1851 18.8917L46.2353 18.5082V18.1247L46.3312 17.7412L46.1942 17.3577L46.3586 16.9742L46.3084 16.5907L46.3358 16.2072V15.8237L46.2536 15.4448L46.3221 15.0613L46.3084 14.6778L46.2399 14.2989L46.1349 13.9246L46.1988 13.5411L46.1577 13.1622L46.1805 12.7787L46.0984 12.4043L46.0481 12.0254L46.0299 11.6419L45.9203 11.2675L45.8564 10.8932L45.9431 10.5006L45.8153 10.1308L45.7286 9.76097V9.37748L45.6236 9.01226L45.6007 8.68355L45.2675 8.6379L44.8931 8.55116L44.5142 8.5192L44.1261 8.57855L43.7563 8.42789L43.3729 8.4142L42.9985 8.35028H42.615L42.2406 8.29093L41.8617 8.24528L41.4782 8.23158L41.1039 8.15397L40.7341 8.05354L40.3552 8.01245L39.9808 7.93484L39.6019 7.87549L39.2458 7.70657L38.8714 7.63352L38.4697 7.7157L38.1181 7.53765L37.7575 7.41439L37.3786 7.3733H36.9859L36.6435 7.17699H36.2509L35.872 7.10851L35.525 6.92133L35.1415 6.87568L34.7991 6.68393L34.4385 6.5561L34.023 6.60632L33.708 6.32784L33.3382 6.2274L32.9593 6.16348L32.5713 6.11327L32.2197 5.96261L31.9047 5.71152L31.5167 5.65217L31.124 5.60195L30.809 5.36455L30.421 5.30063L30.1151 5.03584L29.759 4.89888L29.4257 4.70714L29.0468 4.61583L28.709 4.43778L28.3757 4.25061L28.0333 4.08169L27.6498 3.99038L27.3439 3.74842L26.997 3.58863L26.6409 3.44254L26.2711 3.31015L26.02 2.98144L25.6365 2.87644L25.358 2.59795L25.043 2.38338L24.7143 2.18707L24.4176 1.94511L24.0478 1.83554L23.7465 2.04098L23.3721 2.16425L23.0845 2.42447L22.8106 2.70752L22.4773 2.89927L22.1029 3.02253L21.7788 3.22797L21.4592 3.44254L21.0894 3.5658L20.7333 3.71646L20.3864 3.88081L20.0714 4.09995L19.7472 4.30996L19.3683 4.40583L19.0168 4.56105L18.6835 4.74823L18.3365 4.90801L18.0261 5.14998L17.6837 5.32803L17.2956 5.39194L16.9213 5.48325L16.5606 5.61564L16.241 5.85304L15.8712 5.95804L15.4923 6.03109L15.1545 6.2274L14.7847 6.32784L14.4377 6.49675L14.0451 6.52415L13.6616 6.5835L13.3329 6.82089L12.954 6.89394L12.5751 6.96242L12.2235 7.1359L11.8492 7.22264L11.4611 7.25003L11.1142 7.44634L10.7124 7.40982L10.3654 7.61526H9.97282L9.5802 7.597L9.2378 7.8344L8.83605 7.76135L8.47996 7.93484L8.1056 8.00332L7.72211 8.03527L7.33862 8.05354L6.96426 8.11288L6.58078 8.12201L6.20642 8.20419L5.84119 8.35941L5.45314 8.34115L5.07878 8.44615L4.68616 8.33659L4.31637 8.45985L3.93744 8.51463H3.55852L3.17503 8.49637L2.79611 8.48268L2.45827 8.6242H2.40805Z" stroke="#333333" strokeWidth="1.00071" strokeMiterlimit="10"/>
			<path d="M21.925 16.6178L21.9478 16.2298L22.0574 15.8554L22.2537 15.513L22.5094 15.2163L22.8244 14.9789L23.1759 14.81L23.5457 14.6821L23.9337 14.6502L24.025 14.6593L24.3994 14.7095L24.7601 14.8282L25.1025 15.0017L25.3764 15.2619L25.632 15.5404L25.8238 15.8737L25.906 16.2435L25.9744 16.6178L25.9653 16.9968L25.9607 17.3757L25.9699 17.7546L25.9653 18.1335L25.9562 18.5125L25.9607 18.8914L25.9471 19.2703L25.9607 19.6492L25.9471 20.0327V20.4162L25.9607 20.7951L25.906 21.1832L25.7964 21.553L25.6138 21.8999L25.3627 22.2012L25.0522 22.4432L24.7007 22.6121L24.3264 22.7354L23.9337 22.7719L23.5502 22.708L23.1759 22.603L22.8152 22.4432L22.5139 22.1921L22.2583 21.8999L22.0574 21.5621L21.9524 21.1832L21.9113 20.7951L21.9067 20.4162L21.9113 20.0373L21.9022 19.6584L21.925 19.2794L21.9113 18.9005L21.9204 18.5216L21.9159 18.1427V17.7637L21.9022 17.3848V17.0013L21.925 16.6178Z" fill="#333333"/>
			<path d="M8.89544 22.7401L8.64891 22.4388L8.46173 22.1009L8.35216 21.7266L8.32477 21.3431L8.34303 20.955L8.47542 20.5944L8.64891 20.2474L8.9137 19.9644L8.97761 19.8913L9.28349 19.6585L9.63046 19.4987L10.0002 19.4074L10.3837 19.3846L10.7627 19.4393L11.1325 19.5352L11.4703 19.7133L11.767 19.9598L12.0455 20.2246L12.3194 20.4939L12.6025 20.7542L12.8673 21.0372L13.1549 21.2929L13.4379 21.5577L13.6936 21.8407L13.9904 22.0964L14.2643 22.3703L14.5382 22.6442L14.8258 22.909L15.0723 23.2057L15.2504 23.5481L15.3737 23.9134L15.3965 24.3014L15.3737 24.6849L15.2458 25.0501L15.0586 25.3834L14.8212 25.6847L14.5062 25.9221L14.1593 26.1093L13.7804 26.2234L13.3877 26.2691L12.9951 26.228L12.6162 26.1093L12.2601 25.9404L11.9496 25.6939L11.6894 25.4062L11.4109 25.1414L11.1188 24.8904L10.8494 24.6119L10.5709 24.3516L10.2879 24.0869L10.0185 23.8084L9.74459 23.539L9.46154 23.2742L9.18305 23.0003L8.9 22.7355L8.89544 22.7401Z" fill="#333333"/>
			<path d="M13.3329 31.6105L13.5201 31.2589L13.7393 30.9394L13.9812 30.638L14.2323 30.3459L14.4788 30.0537L14.7071 29.7387L14.9536 29.4419L15.2732 29.2137L15.5517 28.9489L15.8165 28.6658L16.1178 28.4284L16.4237 28.1956L16.725 27.9491L17.0217 27.7025L17.3596 27.5108L17.6883 27.3099L18.0307 27.1319L18.3913 26.9903L18.7109 26.7621L19.0898 26.6662L19.4277 26.4699L19.8112 26.3923L20.1627 26.2325L20.5234 26.0955L20.8977 26.0042L21.2766 25.9175L21.6601 25.8581L22.0436 25.817L22.418 25.7166L22.806 25.6846L23.1895 25.6801L23.5776 25.6664L23.9656 25.6618L24.3491 25.6344L24.7326 25.712L25.1207 25.6938L25.5087 25.7166L25.8831 25.8399L26.2757 25.8307L26.65 25.9266L27.0198 26.027L27.3988 26.1047L27.7686 26.2279L28.1247 26.374L28.4944 26.4881L28.8368 26.6708L29.2066 26.7895L29.5399 26.9903L29.8777 27.1684L30.2338 27.3236L30.5488 27.5473L30.8821 27.7391L31.2108 27.9399L31.5395 28.1499L31.8363 28.3919L32.1148 28.6658L32.4298 28.8895L32.7128 29.1589L32.9274 29.4876L33.2013 29.7569L33.5026 30.008L33.7218 30.3276L33.9637 30.6289L34.2011 30.9302L34.3883 31.2726L34.5892 31.5968L34.2103 31.6105L33.8313 31.6059L33.457 31.6242L33.078 31.5648L32.6991 31.6013L32.3248 31.5831L31.9458 31.5922L31.5715 31.5968L31.1926 31.6242L30.8136 31.6287L30.4393 31.6242L30.0604 31.6196L29.6814 31.5739L29.3025 31.5968L28.9236 31.6424L28.5447 31.5785L28.1657 31.6242L27.7868 31.6105L27.4079 31.6059L27.029 31.5785L26.65 31.5602L26.2711 31.6242L25.8922 31.5648L25.5133 31.6424L25.1344 31.5968L24.7554 31.5694L24.3765 31.5648L23.993 31.6013H23.6141L23.2352 31.6242L22.8562 31.6105H22.4773L22.0984 31.6333L21.7149 31.5694H21.336H20.9571L20.5781 31.6424L20.1947 31.6287L19.8157 31.6242L19.4368 31.5648L19.0533 31.5602L18.6744 31.5922L18.2955 31.6013L17.9165 31.6379L17.5376 31.6333L17.1541 31.5831L16.7752 31.6287L16.3963 31.6105L16.0128 31.6242L15.6339 31.5602L15.2504 31.5785L14.8715 31.5648L14.488 31.6379L14.1045 31.5648L13.721 31.6013L13.3329 31.6105Z" fill="#333333"/>
			<path d="M39.022 22.7219L38.7436 22.9866L38.4788 23.2697L38.1957 23.5299L37.9127 23.7947L37.6342 24.0595L37.3603 24.3289L37.0863 24.5982L36.817 24.8767L36.5431 25.1506L36.26 25.42L35.977 25.6848L35.662 25.9222L35.315 26.1002L34.9361 26.2189L34.5434 26.2646L34.1554 26.2052L33.7765 26.1002L33.4249 25.9313L33.1191 25.6802L33.0506 25.6117L32.8177 25.3195L32.6397 24.9863L32.5484 24.6256L32.521 24.2512L32.5712 23.8769L32.699 23.5299L32.8634 23.1921L33.1236 22.9227L33.3838 22.6397L33.676 22.384L33.9408 22.1055L34.2147 21.8316L34.4932 21.5668L34.7671 21.2975L35.0502 21.0327L35.3332 20.7725L35.598 20.4894L35.8811 20.2246L36.1641 19.9598L36.4746 19.7133L36.8261 19.5352L37.205 19.412L37.5977 19.3983L37.9903 19.4165L38.3738 19.5215L38.7116 19.7224L39.0357 19.9507L39.2823 20.2474L39.4649 20.5898L39.5881 20.9596L39.6247 21.3431L39.5744 21.7266L39.4694 22.0964L39.2686 22.4297L39.0312 22.731L39.022 22.7219Z" fill="#333333"/>
		</g>
		<defs>
			<clipPath id="clip0_547_6760">
			<rect width="46.078" height="47.9954" fill="white" transform="translate(0.960754 0.968048)"/>
			</clipPath>
		</defs>
	</svg>
)

const RequestHelpMenuIcon = ({ fill = '#7f7f7fff', width = '48px', height = '48px' }) => (
  <svg
    version="1.1"
    width={width}
    height={height}
    style={{
      shapeRendering: 'geometricPrecision',
      textRendering: 'geometricPrecision',
      imageRendering: 'optimizeQuality',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
  >
    <g style={{ fillOpacity: 1 }}>
      <path
        style={{ opacity: 0.919 }}
        fill={fill}
        d="M15.5,-0.5C22.5,-0.5 29.5,-0.5 36.5,-0.5C37.618,5.084 37.785,10.751 37,16.5C33.541,17.133 30.041,17.8 26.5,18.5C22.032,26.821 19.366,26.488 18.5,17.5C17.178,17.67 16.011,17.337 15,16.5C14.215,10.751 14.382,5.084 15.5,-0.5Z M25.5,5.5C26.683,6.504 28.016,7.338 29.5,8C28.929,9.205 28.262,10.372 27.5,11.5C26.575,10.36 25.741,10.36 25,11.5C24.682,9.939 23.849,8.772 22.5,8C24.119,7.764 25.119,6.931 25.5,5.5Z"
      />
      <path
        style={{ opacity: 0.884 }}
        fill={fill}
        d="M7.5,19.5C17.174,18.849 19.84,22.849 15.5,31.5C6.368,34.203 2.868,30.87 5,21.5C5.995,20.934 6.828,20.267 7.5,19.5Z"
      />
      <path
        style={{ opacity: 0.884 }}
        fill={fill}
        d="M32.5,19.5C42.174,18.849 44.84,22.849 40.5,31.5C31.368,34.203 27.868,30.87 30,21.5C30.995,20.934 31.828,20.267 32.5,19.5Z"
      />
      <path
        style={{ opacity: 0.909 }}
        fill={fill}
        d="M1.5,34.5C7.833,34.5 14.167,34.5 20.5,34.5C21.641,41.86 18.474,45.193 11,44.5C3.526,45.193 0.359,41.86 1.5,34.5Z"
      />
      <path
        style={{ opacity: 0.909 }}
        fill={fill}
        d="M26.5,34.5C32.833,34.5 39.167,34.5 45.5,34.5C46.641,41.86 43.474,45.193 36,44.5C28.526,45.193 25.359,41.86 26.5,34.5Z"
      />
    </g>
  </svg>
);

const DonateIcon = ({ fill }) => (
	<svg
	  xmlns="http://www.w3.org/2000/svg"
	  width="8mm"
	  height="8mm"
	  viewBox="0 0 100 100"
	  style={{ shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd' }}
	>
	  <g>
		<path
		  style={{ opacity: 0.95 }}
		  fill={fill}
		  d="M 58.5,-0.5 C 61.5,-0.5 64.5,-0.5 67.5,-0.5C 74.9354,1.54827 81.9354,4.71493 88.5,9C 93.9819,13.4144 93.8152,17.5811 88,21.5C 85.112,27.2773 82.7787,33.2773 81,39.5C 79.0417,44.5904 76.2084,49.0904 72.5,53C 65.9417,57.4464 58.9417,61.1131 51.5,64C 46.4074,69.4611 40.2407,72.9611 33,74.5C 23.9293,73.4326 20.2626,68.4326 22,59.5C 26.1005,51.8665 32.2672,46.6999 40.5,44C 42.6201,41.5913 44.6201,39.0913 46.5,36.5C 43.9728,35.7864 41.4728,35.1197 39,34.5C 36.4634,37.372 33.6301,39.872 30.5,42C 31.5171,43.0495 31.6838,44.2161 31,45.5C 25.5925,49.0733 21.4258,53.74 18.5,59.5C 15.5207,53.7367 13.0207,47.7367 11,41.5C 11.5273,30.2723 16.0273,20.7723 24.5,13C 35.9726,8.5708 47.306,4.0708 58.5,-0.5 Z"
		/>
	  </g>
	  <g>
		<path
		  style={{ opacity: 0.932 }}
		  fill={fill}
		  d="M 44.5,99.5 C 39.8333,99.5 35.1667,99.5 30.5,99.5C 16.061,92.2897 12.061,81.2897 18.5,66.5C 24.2528,77.3607 32.5862,79.8607 43.5,74C 47.3826,70.4496 51.5493,67.2829 56,64.5C 63.6397,80.0801 59.8064,91.7468 44.5,99.5 Z"
		/>
	  </g>
	</svg>
);

const QuickAccessIcon = () => (
  <svg
    width="12mm"
    height="12mm"
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        style={{
          fill: "#675747",
          strokeWidth: "0.5",
          strokeLinecap: "round",
          strokeLinejoin: "bevel",
        }}
        d="M 12,6 A 6,6 0 0 1 6,12 6,6 0 0 1 0,6 6,6 0 0 1 6,0 6,6 0 0 1 12,6 Z"
      />
      <path
        style={{
          fontSize: "40px",
          lineHeight: "1.3",
          fontFamily: "'MS UI Gothic'",
          textAlign: "justify",
          letterSpacing: "-1px",
          fill: "#ffffff",
          strokeWidth: "1.88976",
          strokeLinecap: "round",
          strokeLinejoin: "bevel",
        }}
        d="m 323.72656,709.13867 q 0,-4.0625 2.65625,-6.71875 1.875,-1.875 5,-1.875 3.4375,0 5.3125,1.875 2.03125,2.03125 2.03125,5.15625 0,2.65625 -1.875,4.53125 -1.09375,1.09375 -2.96875,2.96875 -1.40625,1.40625 -1.40625,4.21875 h -2.8125 q 0,-3.4375 1.09375,-5.15625 0.78125,-1.25 2.96875,-3.4375 1.25,-1.25 1.25,-2.96875 0,-2.1875 -1.09375,-3.28125 -0.9375,-0.9375 -2.65625,-0.9375 -1.40625,0 -2.34375,0.9375 -1.5625,1.5625 -1.5625,4.6875 z m 5.625,14.6875 h 3.4375 v 3.75 h -3.4375 z"
        transform="matrix(0.26458333,0,0,0.26458333,-81.594,-182.61113)"
      />
    </g>
  </svg>
);
  
const GoalSlurIcon = () => (
	<svg
	  width="18.399mm"
	  height="5.696mm"
	  viewBox="0 0 18.399 5.696"
	  xmlns="http://www.w3.org/2000/svg"
	>
	  <defs>
		<filter
		  id="filter494"
		  x="-0.022252707"
		  y="-0.087194502"
		  width="1.0322767"
		  height="1.1742995"
		>
		  <feGaussianBlur stdDeviation="0.056612799" />
		</filter>
	  </defs>
	  <g>
		<path
		  style={{
			mixBlendMode: "normal",
			fill: "none",
			stroke: "#59c058",
			strokeWidth: "0.5",
			strokeLinecap: "round",
			strokeLinejoin: "bevel",
			filter: "url(#filter494)"
		  }}
		  d="M 20.47906,28.94571 c 0,0 6.5552,7.22034 7.70475,3.21551 1.14955,-4.00481 9.6356,-2.70156 9.6356,-2.70156 l -0.83037,0.072"
		  transform="matrix(1.0000064,0,0,1,-19.843894,-28.310416)"
		/>
	  </g>
	</svg>
);
  
const GoalLeavesIcon = () => (
	<svg
	  width="34.609001mm"
	  height="34.675999mm"
	  viewBox="0 0 34.609001 34.675999"
	  xmlns="http://www.w3.org/2000/svg"
	>
	    <g
			id="layer1"
		>
			<g
				id="g1-9"
				transform="matrix(0.26458333,0,0,0.26458333,-3.7289937,-3.7013879)"
				style={{clipRule:"evenodd", fill:"#c2e5c6", fillOpacity:1, fillRule:"evenodd", stroke:"#59c058", strokeOpacity:1, imageRendering:"optimizeQuality", shapeRendering:"geometricPrecision", textRendering:"geometricPrecision"}}
			>
				<path
					style={{opacity:0.961, fill:"#c2e5c6", fillOpacity:1, stroke:"#59c058", strokeOpacity:1}}
					fill="#000000"
					d="m 24.5,14.5 c 32.4701,-0.4317 58.1368,12.4016 77,38.5 -12.5257,7.0256 -22.1923,16.859 -29,29.5 -2.3265,-8.3216 -5.4932,-16.3216 -9.5,-24 -0.6543,-1.1956 -1.1543,-1.1956 -1.5,0 4.2499,10.0775 6.9165,20.5775 8,31.5 -4.7595,13.747 -5.0929,27.581 -1,41.5 -23.0809,-6.56 -39.2475,-21.227 -48.5,-44 -7.5304,-22.7554 -7.1971,-45.422 1,-68 0.9973,-1.8231 2.1639,-3.4897 3.5,-5 z"
					id="path1-4" 
				/>
			</g>
			<g
				id="g2-0"
				transform="matrix(0.26458333,0,0,0.26458333,-3.7289937,-3.7013879)"
				style={{clipRule:"evenodd", fill:"#c4e6c8", fillOpacity:1, fillRule:"evenodd", stroke:"#59c058", strokeOpacity:1, imageRendering:"optimizeQuality", shapeRendering:"geometricPrecision", textRendering:"geometricPrecision"}}
			>
				<path
					style={{opacity:0.947, fill:"#c4e6c8", fillOpacity:1, stroke:"#59c058", strokeOpacity:1}}
					fill="#000000"
					d="m 131.5,53.5 c 2.599,0.0494 4.766,1.0494 6.5,3 7.807,17.7456 8.473,35.7456 2,54 -10.865,20.67 -28.032,32.004 -51.5,34 0.7129,-12.316 5.2129,-22.983 13.5,-32 5.134,-4.133 9.968,-8.633 14.5,-13.5 -13.69,7.023 -24.1904,17.523 -31.5,31.5 -1.2023,3.274 -2.2023,6.607 -3,10 -9.706,-21.37 -8.3727,-42.0367 4,-62 11.9296,-14.215 27.096,-22.5483 45.5,-25 z"
					id="path2-8" 
				/>
			</g>
		</g>
	</svg>
);
  
  
export {
    SidebarHeadNonagon,
    SidebarHeaderHexagon2,
    HistoryIconSVG,
    MenuCloseIcon,
    MenuIcon,
    MenulistPentagonIcon,
    RegisteredCheckCircle,
    CheckMarkIcon,
	CampaignIcon,
	ImpactIcon,
	AccountInfoIcon,
	EventRegistrationIcon,
	RequestFormEasyIcon,
	RequestFormPowerfulIcon,
	RequestFormTruestedIcon,
	RequestHelpMenuIcon,
	DonateIcon,
	QuickAccessIcon,
	GoalSlurIcon,
	GoalLeavesIcon,
}